import { render, staticRenderFns } from "./GuppyChatQuotedMessages.vue?vue&type=template&id=3c511940&"
import script from "./GuppyChatQuotedMessages.vue?vue&type=script&lang=js&"
export * from "./GuppyChatQuotedMessages.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatQuotedMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports